import React from 'react';
import { useSiteSettings } from '../../SiteSettingsContext';
import { ReviewStars } from '../../product/reviewDisplay';

export default function HomeTestimonials() {
  const { settings: site } = useSiteSettings();
  const store = site.store_copy || {};

  if (store.home_testimonials_enabled !== true) return null;

  const items = Array.isArray(store.home_testimonials) ? store.home_testimonials : [];
  if (!items.length) return null;

  const title = store.home_testimonials_title || 'What customers say';

  return (
    <section className="home-testimonials" aria-label={title}>
      <div className="container store-page__container">
        <h2 className="home-testimonials__heading text-center">{title}</h2>
        <div className="home-testimonials__track" role="list">
          {items.map((t, i) => (
            <article className="home-testimonials__card" key={`review-${i}-${t.name}`} role="listitem">
              <ReviewStars rating={t.stars} className="home-testimonials__stars" />
              <blockquote className="home-testimonials__quote">&ldquo;{t.quote}&rdquo;</blockquote>
              <footer className="home-testimonials__name">{t.name}</footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
